// extracted by mini-css-extract-plugin
export default {"deleteList":"styles_deleteList__2JGpU","select":"styles_select__HTVui"};